module.exports = __webpack_public_path__ + "img/failure.7b9253f1.svg";